import React from 'react';
import { Spin, Alert } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import TimeSeriesChart from '../visualizations/TimeSeriesChart';
import GaugeChart from '../visualizations/GaugeChart';
import StatChart from '../visualizations/StatChart';
import PieChart from '../visualizations/PieChart';
import TableChart from '../visualizations/TableChart';
import { useTheme } from '../../context/ThemeContext';

const PanelVisualization = ({ panel }) => {
  const { isDark } = useTheme();
  const { type, data, options, fieldConfig, loading, error } = panel;

  if (loading) {
    return (
      <div 
        className="panel-loading"
        style={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          gap: 12
        }}
      >
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          size="large"
        />
        <span style={{ 
          color: isDark ? '#58a6ff' : '#1890ff',
          fontSize: 13
        }}>
          Loading data...
        </span>
      </div>
    );
  }

  if (error) {
    return (
      <div 
        className="panel-error"
        style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          padding: 16
        }}
      >
        <Alert
          message="Query Error"
          description={error}
          type="error"
          showIcon
          style={{ 
            maxWidth: '100%',
            background: isDark ? '#1c1917' : '#fff2f0',
            border: isDark ? '1px solid #5c2626' : '1px solid #ffccc7'
          }}
        />
      </div>
    );
  }

  switch (type) {
    case 'timeseries':
      return <TimeSeriesChart data={data} options={options} fieldConfig={fieldConfig} />;
    case 'gauge':
      return <GaugeChart data={data} options={options} fieldConfig={fieldConfig} />;
    case 'stat':
      return <StatChart data={data} options={options} fieldConfig={fieldConfig} />;
    case 'pie':
      return <PieChart data={data} options={options} fieldConfig={fieldConfig} />;
    case 'table':
      return <TableChart data={data} options={options} fieldConfig={fieldConfig} />;
    default:
      return (
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          gap: 8
        }}>
          <Alert
            message="Unsupported Panel Type"
            description={`Panel type "${type}" is not supported yet.`}
            type="warning"
            showIcon
            style={{ 
              background: isDark ? '#2d2a1e' : '#fffbe6',
              border: isDark ? '1px solid #594214' : '1px solid #ffe58f'
            }}
          />
        </div>
      );
  }
};

export default PanelVisualization;